import styled from '@mui/material/styles/styled'
import MuiAccordionDetails from '@mui/material/AccordionDetails'

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: 0,
  paddingTop: theme.spacing(2),
}))
